import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Contact } from '@tcc-mono/vandijk/shared/data-access/models';
import { ContactService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactRepository extends CoreRepository<Contact> {

  public contacts$: Observable<Contact[]> = this.entities$;
  public selectedContact$: Observable<Contact> = this.activeEntity$;

  public constructor(
    protected readonly _contactService: ContactService
  ) {
    super(
      { name: 'contacts' },
      _contactService
    )
  }

  public addContact = (contact: Partial<Contact>): Observable<Contact> => {
    return this.addEntity(contact);
  }

  public updateContact = (contactId: number, contact: Contact): Observable<Contact> => {
    return this.updateEntity(contactId, contact);
  }

  public getContact = (contactId: number): Observable<Contact> => {
    return this.getEntity(contactId);
  }

  public removeContact = (contactId: number): Observable<unknown> => {
    return this.removeEntity(contactId);
  }

  public setActiveContact = (contactId: number): void => {
    this.setActiveEntity(contactId);
  }
}
